export default "__VITE_ASSET__DlKE9PGe__"